import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { shuffle } from "../../util/generalUtil";
import { VerseCardsGame } from "./VerseCardsGame";
import { useSelector } from "react-redux";
import { RootStore } from "../../state/store";
import { VerseType } from "../../types/practiceTypes";

export function VerseCards() {
  useDocumentTitle("Verse Cards - Bible Quiz Academy");
  const material = useSelector((state: RootStore) => state.material.material);
  const settings = useSelector((state: RootStore) => state.settings);
  const chapters = settings.selectedChapters;
  const [randomized, setRandomized] = useState<VerseType[]>([]);

  // Get verse array, possibly randomized
  useEffect(() => {
    if (material.length === 0) return;
    const allVerses: VerseType[] = [];
    material.forEach((book, index) => {
      book.chapters.forEach((chapter, chapterIndex) => {
        if (chapters && chapters[index] && chapters[index][chapterIndex]) {
          chapter.forEach((verse, verseIndex) => {
            const chapterFromSettings = chapters[index][chapterIndex];
            const chapterSettings =
              typeof chapterFromSettings === "boolean"
                ? Array(chapter.length).fill(chapterFromSettings)
                : chapterFromSettings;
            if (chapterSettings[verseIndex]) {
              allVerses.push({
                book: index,
                chapter: chapterIndex,
                verseNum: verseIndex,
                reference: `${book.bookName} ${chapterIndex + 1}:${
                  verseIndex + 1
                }`,
                ...verse,
              });
            }
          });
        }
      });
    });
    if (settings.vcRandomize) shuffle(allVerses);
    setRandomized(allVerses);
  }, [material]);

  if (chapters.length === 0) {
    return <Navigate to="/" />;
  }

  return <VerseCardsGame material={randomized} allowImport />;
}
